import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad1CBlue1BBlack1EBlue = () => <CrossRoad coords="959.000000, 843.000000"/>;
export default CrossRoad1CBlue1BBlack1EBlue;